import type { NewRelicErrorHandler } from '../types';

export const ERROR_IGNORE_SUBSTRINGS = [
  // clarity
  "Cannot read properties of null (reading 'disconnect')",
  'n.replace is not a function',
  'clarity',
  // hooper(carousel library)
  "undefined is not an object (evaluating 't.touches[0]')",
  // bigbrother投げてる途中でページ遷移すると起こる
  'XMLHttpRequestProgressEvent',
  // 401
  'Unauthorized',
  'Not Authenticated',
  'Received status code 401',
  'Request failed with status code 401',
  'Response not successful: Received status code 401',
  // 重複回答
  'Already Exists',
  // Timeout
  'timeout',
  'Request timed out',
  // Network error
  'Network Error',
  'Failed to fetch',
  'Load failed',
  'Request aborted',
  // ページ遷移やコンポーネントの unmount で待ち手のいなくなった fetch の中断
  // （ブラウザ由来、および Apollo の unsubscribe による abort）。Safari はどちらも同じ文言。
  // タイムアウトを AbortController で実装するとここに吸われるので、タイムアウトには
  // AbortSignal.timeout() を使うこと（TimeoutError になり文言が変わる）。
  'The user aborted a request.',
  'Fetch is aborted',
  'socket is not opened',
  // 謎の拡張エラー
  'learningToolsRuntimeBridge',
  // 404
  'アンケートが見つかりません',
  // 404（Ponta の存在しない投票へのアクセス）
  '投票が見つかりません',
  // kenall 404（郵便番号検索の存在しない郵便番号）
  'error: kenall. AxiosError: Request failed with status code 404',
  // Chrome extensions
  'extensions/',
  'chrome://',
  'chrome-extension://',
  // local file
  'file://',
  // GTM (GTM-MJGGH4K) 経由で挿入されたタグ由来のエラー。
  // GPT が未ロードの環境で `googletag` を参照して ReferenceError になるものを含む。
  // アプリのコードは googletag を一切参照していないため、まとめて無視する。
  'googletag',
  // ブラウザ仕様上の警告（無害）
  'ResizeObserver loop',
  // インラインスクリプト（GTM / ブラウザ拡張）が JSON-LD を読んで落ちるもの。
  // アプリのコードは JSON-LD を出力するだけで読み取らないため、この評価式は外部由来。
  // Safari の文言にだけ一致する。Chrome は "Cannot read properties of undefined (reading
  // 'toLowerCase')" とプロパティパスを落とすため外部由来と判別できず、対象にしていない。
  '["@context"].toLowerCase',
  // iOS の WebView が注入したスクリプト由来。アプリのバンドルは通常の https URL を持つため
  // このスキームでスタックが出るものはアプリのコードではない。
  'webkit-masked-url',
  // 外部のヘルプウィジェットが自前の meta タグを見つけられずに落ちるもの
  'help-header-icon',
  // WebView 前提の外部スクリプトを通常のブラウザで実行したもの
  'window.webkit.messageHandlers',
] as const;

export function createErrorHandler(): NewRelicErrorHandler {
  return (error) => {
    if (!error) {
      return false;
    }

    const text = extractErrorText(error);
    if (!text) {
      return false;
    }

    const normalizedText = text.toLowerCase();

    const shouldIgnore = ERROR_IGNORE_SUBSTRINGS.some((substring) =>
      normalizedText.includes(substring.toLowerCase())
    );

    return shouldIgnore;
  };
}

// WebKit では error.stack に "Name: message" の先頭行が含まれないため、
// name / message / stack を結合してマッチング対象を広げる
export function extractErrorText(error: unknown): string | null {
  if (typeof error === 'string') {
    return error;
  }

  if (error instanceof Error) {
    const parts = [error.name, error.message, error.stack].filter(Boolean);
    return parts.length > 0 ? parts.join('\n') : null;
  }

  if (typeof error === 'object' && error !== null) {
    const obj = error as { name?: unknown; message?: unknown; stack?: unknown };
    const parts = [obj.name, obj.message, obj.stack]
      .filter((v) => typeof v === 'string' && v.length > 0)
      .join('\n');
    return parts.length > 0 ? parts : null;
  }

  return null;
}
